import session from './session';
/**
 * In the case that more state slices are introduced with multiple reducers.
 * combineReducer will be used and this file will be the rootReducer.
 */
export default session;
